import { render } from "./AShare.vue?vue&type=template&id=39671718"
import script from "./AShare.vue?vue&type=script&lang=js"
export * from "./AShare.vue?vue&type=script&lang=js"

import "./AShare.vue?vue&type=style&index=0&id=39671718&lang=scss"

import exportComponent from "/home/runner/work/eoy-2022-frontend/eoy-2022-frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__